<template>

  <div>
    <el-row :gutter="18" align="bottom">
      <el-col :sm="24" :md="10">
        <h2><i class="fa fa-share-alt">&nbsp;</i><org-badge /> {{ title }}</h2>
      </el-col>
    </el-row>

<!-- v-if="isTelco() && telcoId ? true : (isTowerCo() ? true : false)" -->

    <div style="padding-top: 1.2em">
      <el-tabs type="border-card" v-model="menu">

        <el-tab-pane name="report">
            <span slot="label"><i class="fa fa-globe"></i> Summary</span>

            <el-tabs tab-position="right">
              <el-tab-pane>
                  <span slot="label"><i class="fa fa-share-alt"></i> Requests Report</span>
                  <requests-report :sharer="telcoId" :stats="stats" />
              </el-tab-pane>

              <el-tab-pane name="stale-report" lazy>
                  <span slot="label"><i class="fa fa-minus"></i> Stale Requests</span>

                  <stale-request-report />
              </el-tab-pane>

            </el-tabs>

        </el-tab-pane>


        <el-tab-pane v-if="isTelco() || canAccess('project|maintenance|finance|admin|management')" name="acquire" lazy>
            <span slot="label"><i class="fa fa-street-view"></i> Acquire&nbsp;<span v-if="stats.rta > 0" class="badge">&nbsp;{{stats.rta}}&nbsp;</span></span>

          <request-table type="RTA" heading="Acquire" :sharer="telcoId" :site-id="siteId" :rejected="stats.rtaRejected" :active="stats.rta" :closed="stats.rtaClosed"  />
        </el-tab-pane>


        <el-tab-pane v-if="isTelco() || canAccess('project|maintenance|finance|admin|management')" name="share" lazy>
            <span slot="label"><i class="fa fa-share-alt"></i> New Shares&nbsp;<span v-if="stats.rts > 0" class="badge">&nbsp;{{stats.rts}}&nbsp;</span></span>

          <request-table type="RTS" heading="Share" :sharer="telcoId" :site-id="siteId" :rejected="stats.rtsRejected" :active="stats.rts" :closed="stats.rtsClosed"  />
        </el-tab-pane>


        <el-tab-pane v-if="isTelco() || canAccess('project|maintenance|finance|admin|management')" name="upgrade" lazy>
          <span slot="label"><i class="fa fa-tools"></i> Upgrades&nbsp;<span v-if="stats.rtu > 0" class="badge">&nbsp;{{stats.rtu}}&nbsp;</span></span>

          <request-table type="RTU" heading="Upgrade" :sharer="telcoId" :site-id="siteId" :rejected="stats.rtuRejected" :active="stats.rtu" :closed="stats.rtuClosed" />
        </el-tab-pane>


        <el-tab-pane v-if="(isTelco() || isBackhaulCo()) || canAccess('project|maintenance|finance|admin|management')" name="backhaul" lazy>
          <span slot="label"><i class="fa fa-wifi"></i> Backhaul&nbsp;<span v-if="stats.rtb > 0" class="badge">&nbsp;{{stats.rtb}}&nbsp;</span></span>

          <request-table type="RTB" heading="Backhaul" :sharer="telcoId" :site-id="siteId" :rejected="stats.rtbRejected" :active="stats.rtb" :closed="stats.rtbClosed" />
        </el-tab-pane>

        <el-tab-pane v-if="isTelco() || canAccess('project|maintenance|finance|admin|management')" name="dismantle" lazy>
          <span slot="label"><i class="fa fa-xmark"></i> Dismantle&nbsp;<span v-if="stats.rtd > 0" class="badge">&nbsp;{{stats.rtd}}&nbsp;</span></span>

          <request-table type="RTD" heading="Dismantle" :sharer="telcoId" :site-id="siteId" :rejected="stats.rtdRejected" :active="stats.rt" :closed="stats.rtdClosed" />
        </el-tab-pane>



        <el-tab-pane v-if="(isTelco() || isBackhaulCo()) || canAccess('project|maintenance|finance|admin|management')" name="calendar" lazy>
          <span slot="label"><i class="fa fa-calendar"></i> Requests Calendar</span>

          <events-calendar category="requests" :sharer="telcoId" />

        </el-tab-pane>


      </el-tabs>
    </div>

  </div>

</template>

<script>

import StaleRequestReport from '@/components/dashboard/requests/StaleRequestReport'
import RequestsReport from '@/components/dashboard/requests/RequestsReport'

import EventsCalendar from '@/components/atoms/EventsCalendar'

import RequestTable from '@/components/requests/RequestTable'

export default {

  components: {
    EventsCalendar,
    StaleRequestReport,
    RequestTable,
    RequestsReport
  },


  props: {

    type: {
      type: String,
      default: 'report'
    },

    sharer: {
      type: Number,
      default: null
    },

    siteId: {
      type: Number,
      default: null
    }

  },


  methods: {

    updateStats (stats) {
      this.stats = stats
    }

  },


  watch: {
    '$route.params': {
      handler: function (p) {

        if (p.type) {
          this.menu = p.type
        } else {
          this.menu = 'report'
        }

        if (!this.isTelco () && p.sharerId) {

          this.telcoId = (this.isTelco() ? this.org().id : Number(p.sharerId))
          this.refreshStats(this.telcoId, this.updateStats)

        } else {

          this.telcoId = this.org().id
          this.refreshStats(null, this.updateStats)
        }

      },
      deep: true,
      immediate: true
    }

  },



  data () {

    return {
      title: 'Requests',
      menu: this.type,
      stats: this.getStats(),
      telcoId: (this.isTelco() ? this.org().id : this.sharer)
    }
  }
}

</script>

<style scoped>
.badge {
     top:-10px;
     right:-10px;
     font-size:0.8em;
     padding: 0.2em;
     background: #DCDFE6;
     color:#303133;
     text-align:center;
     border-radius:30%;
     box-shadow:0 0 1px #333;
   }
</style>
